import TestManger from "pages/dashboard/shared/TestManger/TestPrograms";
import { FC } from "react";

interface AdminTestSectionProps {}

const AdminTestSection: FC<AdminTestSectionProps> = () => {
  return <TestManger />;
};
export default AdminTestSection;
